import React from 'react';
import { Badge } from 'reactstrap';
import { ContainerStationStatus } from '../../graphql/generatedTypes';
import i18n from '@/utils/i18n';

const getContainerStationStatusColor = (
  status: ContainerStationStatus,
): string => {
  switch (status) {
    case ContainerStationStatus.Counted:
      return 'success';
    case ContainerStationStatus.Empty:
      return 'secondary';
    case ContainerStationStatus.Sealed:
      return 'info';
    case ContainerStationStatus.Uncounted:
      return 'warning';

    default:
      break;
  }

  return 'error';
};

type ContainerStationStatusBadgeProps = {
  status: ContainerStationStatus | null | undefined;
};

const ContainerStationStatusBadge = ({
  status,
}: ContainerStationStatusBadgeProps) => {
  if (!status) {
    return <>-</>;
  }

  return (
    <Badge
      color={getContainerStationStatusColor(status)}
      className="border border-1"
      pill
    >
      {i18n.t(`ContainerStation:status_${status}`)}
    </Badge>
  );
};

export default ContainerStationStatusBadge;
